import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("auth:logout"));
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "Si è verificato un errore. Riprova.") {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "Connessione non disponibile. Controlla la rete e riprova.";
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  if (d.errors?.length) return `${d.message}: ${d.errors.join("; ")}`;
  return d.message || fallback;
}

export function errList(e) {
  const d = e?.response?.data?.detail;
  return d && typeof d === "object" && Array.isArray(d.errors) ? d.errors : [];
}

async function readBlobError(e) {
  if (e?.response?.data instanceof Blob) {
    try {
      const j = JSON.parse(await e.response.data.text());
      e.response.data = j;
    } catch (_) {}
  }
  return e;
}

export async function download(path, params = {}) {
  try {
    const r = await api.get(path, { params, responseType: "blob" });
    const cd = r.headers["content-disposition"] || "";
    const name = (cd.match(/filename="?([^"]+)"?/) || [])[1] || "download";
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch (e) {
    throw await readBlobError(e);
  }
}

export async function openBlob(path) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    window.open(URL.createObjectURL(r.data), "_blank");
  } catch (e) {
    throw await readBlobError(e);
  }
}

export const fmtDate = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("/") : "");
export const todayIso = () => new Date().toLocaleDateString("sv-SE");
